import { withTheme } from '@mui/styles';
import styled from 'styled-components';

import config from 'src/config';
import theme from 'src/theme';

const TermsAndConditionStyle = withTheme(styled.div`
  font-family: Lanna;
  ${theme.breakpoints.up('md')} {
    background: linear-gradient(92.76deg, #538d87 24.56%, #164843 93.61%) no-repeat top center fixed;
    -webkit-background-size: 100% 270px;
    -moz-background-size: 100% 270px;
    -o-background-size: 100% 270px;
    background-size: 100% 270px;
    padding: 80px 0px;
  }
  .container {
    margin: 0px auto;
    width: 1136px;
    background: #ffffff;
    box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
    border-radius: 10px;
    padding: 40px 60px;
    font-size: 18px;
  }
  .paragraph {
    margin: 30px 0px;
  }
  .indent {
    text-indent: 20px;
  }
  .bold {
    font-weight: bold;
  }
  ${theme.breakpoints.down('lg')} {
    .container {
      width: 724px;
      padding: 40px 30px;
    }
  }
  ${theme.breakpoints.down('md')} {
    .container {
      width: 100%;
      padding: 36px 16px;
      border-radius: 0px;
      box-shadow: none;
    }
  }
`);

export default TermsAndConditionStyle;
